import { IMAGES } from "@/lib/site";

const SHOTS = [
  { img: IMAGES.gallery1, alt: "Surfer riding the famous right-hander at Lagundri Bay, Nias", num: "01 · The Wave", label: "Lagundri Bay Right" },
  { img: IMAGES.gallery2, alt: "Swimming pool at Raffiel Nias hotel, Sorake Beach", num: "02 · Recovery", label: "Freshwater Pool" },
  { img: IMAGES.gallery3, alt: "Rooftop café at Raffiel Nias overlooking the ocean", num: "03 · Sunset Deck", label: "Rooftop Ocean Café" },
  { img: IMAGES.gallery4, alt: "Guests relaxing together at Raffiel Nias after a surf session", num: "04 · The Vibe", label: "Post-Surf Community" },
];

const Gallery = () => (
  <section className="py-16 bg-sand-100 border-y border-sand-200" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="flex items-center justify-between mb-8">
        <div>
          <span className="text-xs font-mono-clean text-ocean-700 uppercase tracking-wider">
            Atmosphere & Surrounds
          </span>
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-ocean-900">
            Life at Sorake Beach
          </h2>
        </div>
        <span className="text-xs font-mono-clean text-fog hidden sm:inline">
          Sorake Point · South Nias
        </span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {SHOTS.map((s) => (
          <div key={s.num} className="aspect-[4/5] rounded-xl overflow-hidden relative group">
            <img
              src={s.img}
              alt={s.alt}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ocean-900/80 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
              <span className="text-[11px] font-mono-clean">{s.num}</span>
              <p className="text-xs font-semibold">{s.label}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
